export default "__VITE_ASSET__Cepfmd2f__"